"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetGlobalNamespaceForTesting = exports.getGlobalNamespace = exports.overwriteGlobalNamespace = void 0;
var globalNamespace = {
    singletonPassport: null,
    passportRuntimeOptions: {},
};
function overwriteGlobalNamespace(memPointer) {
    // 保持引用，不可以改成es6
    if (memPointer !== globalNamespace) {
        globalNamespace = memPointer;
        console.log('globalNamespace pointer has been replaced');
    }
}
exports.overwriteGlobalNamespace = overwriteGlobalNamespace;
function getGlobalNamespace() {
    return globalNamespace;
}
exports.getGlobalNamespace = getGlobalNamespace;
function resetGlobalNamespaceForTesting() {
    globalNamespace = {
        singletonPassport: null,
        passportRuntimeOptions: {},
    };
}
exports.resetGlobalNamespaceForTesting = resetGlobalNamespaceForTesting;
//# sourceMappingURL=globalNamespace.js.map